import * as React from 'react';
import { observer } from 'mobx-react';
import { Toggle } from 'office-ui-fabric-react/lib';
import { getOwaCommonStrings } from 'owa-strings/owa-common-strings';
import { getIsDarkTheme } from 'owa-fabric-theme';
import previewDarkModeTheme from '../orchestration/previewDarkModeTheme';
export default observer(function DarkModeFull() {
    return (React.createElement(Toggle, { onText: getOwaCommonStrings().toggle_on, offText: getOwaCommonStrings().toggle_off, checked: getIsDarkTheme(), onChanged: previewDarkModeTheme }));
});
//# sourceMappingURL=DarkModeFull.js.map